import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { EnvironmentProvider } from './contexts/EnvironmentContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Payees from './pages/Payees';
import Payers from './pages/Payers';
import BankAccounts from './pages/BankAccounts';
import PaymentMethods from './pages/PaymentMethods';
import AccountsPayable from './pages/AccountsPayable';
import AccountsReceivable from './pages/AccountsReceivable';
import BankStatement from './pages/BankStatement';
import Analytics from './pages/Analytics';
import InvestmentsList from './pages/InvestmentsList';
import ExpenseCategories from './pages/ExpenseCategories';
import Expenses from './pages/Expenses';
import ExpenseReport from './pages/ExpenseReport';
import AdminHome from './pages/AdminHome';
import AdminAccountCreation from './pages/AdminAccountCreation';
import AdminAccountsList from './pages/AdminAccountsList';
import AdminUsersList from './pages/AdminUsersList';
import AdminAuditLogs from './pages/AdminAuditLogs';
import Register from './pages/Register';
import TwoFactorChallenge from './pages/TwoFactorChallenge';
import Profile from './pages/Profile';
import Security from './pages/Security';
import { authTokenStorage } from './services/api';

const RequireAuth: React.FC = () => {
    const token = authTokenStorage.get();
    if (!token) return <Navigate to="/login" replace />;
    return <Outlet />;
};

const App: React.FC = () => {
    return (
        <EnvironmentProvider>
            <Router>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/two-factor" element={<TwoFactorChallenge />} />
                    <Route path="/register/:token" element={<Register />} />
                    <Route element={<RequireAuth />}>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/profile" element={<Profile />} />
                            <Route path="/security" element={<Security />} />
                            <Route path="/payees" element={<Payees />} />
                            <Route path="/payers" element={<Payers />} />
                            <Route path="/bank-accounts" element={<BankAccounts />} />
                            <Route path="/payment-methods" element={<PaymentMethods />} />
                            <Route path="/accounts-payable" element={<AccountsPayable />} />
                            <Route path="/accounts-receivable" element={<AccountsReceivable />} />
                            <Route path="/bank-statement" element={<BankStatement />} />
                            <Route path="/analytics" element={<Analytics />} />
                            <Route path="/investments" element={<InvestmentsList />} />
                            <Route path="/expense-categories" element={<ExpenseCategories />} />
                            <Route path="/expenses" element={<Expenses />} />
                            <Route path="/expense-report" element={<ExpenseReport />} />
                            <Route path="/admin" element={<AdminHome />} />
                            <Route path="/admin/account-creation" element={<AdminAccountCreation />} />
                            <Route path="/admin/accounts" element={<AdminAccountsList />} />
                            <Route path="/admin/user" element={<AdminUsersList />} />
                            <Route path="/admin/logs" element={<AdminAuditLogs />} />
                        </Route>
                    </Route>
                    <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
            </Router>
        </EnvironmentProvider>
    );
};

export default App;
